var i = function() {
  function e(t, s) {
    this.activeTargets = [], this.skippedTargets = [], this.observationTargets = [], this.observer = t, this.callback = s;
  }
  return e;
}();
export {
  i as ResizeObserverDetail
};
